import { restClient } from '@/Core'

import { toCollection, toHistoryItem } from '../Helpers/diskResponse'

import type { DiskCollection, DiskHistoryItem } from '../Contracts/DiskNode'

/** Журнал вузла, новіші вгорі: `GET /services/disk/nodes/{uuid}/history`. */
export const LoadDiskNodeHistoryTask = async (uuid: string): Promise<DiskCollection<DiskHistoryItem>> => {
    const response = (await restClient.get(
        `/services/disk/nodes/${encodeURIComponent(uuid)}/history`,
        { searchParams: { limit: '50' } },
        { forceRefresh: true }
    )) as unknown

    return toCollection(response, toHistoryItem)
}
